























































































import {
    Vue,
    Component,
} from "@/shared/vuepack";
import { useThemeStore } from "@/shared/store/theme";

@Component({
    components: {
    }
})
export default class PartnerUserBulkDeleteModal extends Vue {
    themeStore = useThemeStore();
}
